import React from "react";
import { Link } from "react-router-dom";
import { Form, Button, Container, Row, Col, Tab, Nav } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import GeneralTabStudentForm from "presentation/pages/students/elements/form-tabs/general";
import ExtraTabStudentForm from "presentation/pages/students/elements/form-tabs/extra";
import HealthTabStudentForm from "presentation/pages/students/elements/form-tabs/health";
import AddressTabStudentForm from "presentation/pages/students/elements/form-tabs/address";
import PhoneTabStudentForm from "presentation/pages/students/elements/form-tabs/phone";

import racesService from "presentation/services/races";
import localitiesService from "presentation/services/localities";
import countriesService from "presentation/services/countries";

class StudentForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            localLoading: true,
            localError: false,
            message: '',
            races: [],
            localities: [],
            countries: [],
        }

    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => {

        let races = [];
        let countries = [];
        let localities = [];

        await racesService.findAll().then((result) => {
            races = result;
        });

        await localitiesService.findAll().then((result) => {
            countries = result;
        });

        await countriesService.findAll().then((result) => {
            localities = result;
        });

        this.setState({ localLoading: false, localities: localities, countries: countries, races: races });
    }

    render() {
        let {
            loading,
            message,
            form,
            addressForm,
            handleChange,
            handleSubmit,
            component,
            phones
        } = this.props;

        let {
            localLoading,
            localError,
            localities,
            countries,
            races
        } = this.state;

        let childrenParams = {
            component: component,
            form: form,
            addressForm: addressForm,
            handleChange: handleChange,
            localities: localities,
            countries: countries,
            races: races,
            phones: phones,
            loading: loading
        };

        return (
            <Form className="mb-5">
                {loading === true || localLoading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                {(localLoading === false && localError === true) && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {
                    loading === false && localLoading === false && (

                        <Container>
                            <Row>
                                <Col>
                                    <Tab.Container id="left-tabs" defaultActiveKey="general">
                                        <Row>
                                            <Col sm={2}>
                                                <Nav variant="pills" className="flex-column">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="general">Dados básicos</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="extra">Dados extra</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="address">Endereço</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="phone">Telefone</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="health">Saúde</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </Col>
                                            <Col sm={10}>
                                                <Container>
                                                    <Row>
                                                        <Col>
                                                            <Tab.Content>
                                                                <Tab.Pane eventKey="general">
                                                                    <GeneralTabStudentForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="extra">
                                                                    <ExtraTabStudentForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="address">
                                                                    <AddressTabStudentForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="phone">
                                                                    <PhoneTabStudentForm {...childrenParams} />
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="health">
                                                                    <HealthTabStudentForm {...childrenParams} />
                                                                </Tab.Pane>
                                                            </Tab.Content>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <div className="mt-3 mb-5">
                                                                <CancelButton
                                                                    containerProps={{
                                                                        as: Link,
                                                                        to: '/alunos'
                                                                    }}
                                                                />
                                                                <Button disabled={loading} variant="success" className="float-end" onClick={() => handleSubmit()}>Salvar</Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                </Col>
                            </Row>
                        </Container>
                    )}
            </Form>
        );
    };
}

export default StudentForm;